export default __webpack_public_path__ + "0bb1c6ff88fa2e555eb0c3a4f8d97787.png";